import {
  ACTIONS, COMPONENT_IN_FOCUS, SESSION_TYPE, USER_ROLES, Modules, FILTER_NAME
} from "UTILS/Constants";

const initialState = {
  sessionTitle: "",
  sessionDetails: {
    sessionKey: "",
    token: "",
    modules: [],   
    bandwidthSettings: [{
      module: "AUDIO_VIDEO",
      bandwidth: 360,
      fps: 15         // frame rate per second
    }, {
      module: "SCREENSHARE",
      bandwidth: 360,
      fps: 15       // frame rate per second
    }] ,
    cobrowseSettings: {cobrowseUrl: "" , cobrowseType:" ", aesKey: ""},
    recordingMethod: "",
    audioRecordingMessage: "",
    videoRecordingMessage: "",
  },
  userSessionDetails: {
    sessionKey: "" 
  },
  currentSessionInvitees: [],
  participantId: null,
  uniqueId: null,
  isOrganizer: false,
  
  webRtcPermissionRequest: null,
  webRtcPermissionReply: null,
  localStream: null,
  headerIcons: [],
  isSessionEnded: false,

  snapshotPermissionReply: null,
  snapshoteeId: null,
  snapshoterId: null,
  isSnapshotTaken: null,
  isSessionJoined: false, //For refresh and nw handling
  showSnapshot: false,
  isCallEnded: false,
  isPeerDisposed: false,
  showAudioVideoComponent: false,
  webrtcSessionMedia: null,
  isCameraPermissionGranted: null,
  stopVideoCall: null,// handle degrading (stop video call if user accept snapshot request)
  startVideoCall: false, // For iPhone orientation change we have to restart call
  isCameraBusy:null,
  turnServer: {},
  createSnapshotRtcPeer:false,
  startSnapshot:false,
  callMediaType:null,
  componentInFocus: COMPONENT_IN_FOCUS.CANVAS,
  sessionsList: null,
  saveSessionDataFlag: false,
  sessionType: SESSION_TYPE.INSTANT_MEETING,
  editSessionData: null,
  passcode: null,
  trailHistoryData: {
    searchKey: "",
    displayPage: 0,
    sessionListPageSize: 10
  },
  waitingUsersData: {
    displayPage: 0,
    sessionListPageSize: 10
  },
  isRecording: false,
  isScreenMasking: false,
  showPreviewModal: false,
  isVideoTransform: false,
  previewAudio: true,
  audioDeviceId: "",
  videoDeviceId: "",
  facingMode: "user",
  showAudioSettingModal: false,
  isFullScreenV2: false,
  isVirtualBackground: false,
  selectedBackground: FILTER_NAME.BLUR,
  contractInfo: [],
  isContractInfoModalOpened: false,
  isDisconnectedWhileCalling: false,
};
export default function (state = initialState, action) {
  switch (action.type) {
    case ACTIONS.JOIN_SESSION:
      if (!_.isEmpty(action.sessionDetails)) {
        let sessionDetailsForSessionStorage = {
          modules: action.sessionDetails.modules,
          subModules: action.sessionDetails.subModules
        };
        sessionStorage.setItem(action.sessionDetails.token, JSON.stringify(sessionDetailsForSessionStorage));
      }
      return {
        ...state,
        sessionDetails: action.sessionDetails
      };
    case ACTIONS.SET_END_SESSION_FLAG:
      return {
        ...state,
        isSessionEnded: action.flag
      };
      break;
    case ACTIONS.VIEW_INVITEES:
      return { ...state, invitees: action.invitees };
    case ACTIONS.CREATE_SESSION_SUCCESS:
      return {
        ...state,
        userSessionDetails: action.userSessionDetails
      };
    case ACTIONS.SAVE_SESSION_TITLE:
      return {
        ...state,
        sessionTitle: action.sessionTitle
      };
    case ACTIONS.SAVE_CURRENT_SESSION_INVITEES:
      return {
        ...state,
        currentSessionInvitees: action.currentSessionInvitees
      };
    case ACTIONS.SET_SESSION_STATUS:
      return {
        ...state,
        sessionDetails: {
          ...state.sessionDetails,
          sessionStatus: action.sessionStatus
        }
      };
    case ACTIONS.SET_WEBRTC_REQUEST_PERMISSION:
      return {
        ...state,
        webRtcPermissionRequest: action.webRtcPermissionRequest
      };
    case ACTIONS.SET_WEBRTC_REPLY_PERMISSION:
      return {
        ...state,
        webRtcPermissionReply: action.webRtcPermissionReply
      };
    case ACTIONS.SET_SESSION_JOINED_FLAG:
      return {
        ...state,
        isSessionJoined: action.isSessionJoined
      };
    case ACTIONS.UPDATE_CURRENT_PARTICIPANT_INFO:
      let currentState = _.cloneDeep(state);
      currentState.participantId = action.currentParticipantInfo.participantId;
      currentState.uniqueId = action.currentParticipantInfo.uniqueId;
      currentState.isOrganizer = action.currentParticipantInfo.isOrganizer;
      let sessionDetailsForSessionStorage = JSON.parse(sessionStorage.getItem(currentState.sessionDetails.token));
      sessionDetailsForSessionStorage.isOrganizer = action.currentParticipantInfo.isOrganizer;
      sessionStorage.setItem(currentState.sessionDetails.token, JSON.stringify(sessionDetailsForSessionStorage));
      return currentState;
    case ACTIONS.SET_HEADER_ICONS:
      return {
        ...state,
        headerIcons: action.headerIcons
      };
    case ACTIONS.UPDATE_HEADER_ICON_CLASSNAME:
      let cstate = _.cloneDeep(state);
      let moduleName = action.data.moduleName;
      if (cstate.headerIcons[moduleName]) {
        cstate.headerIcons[moduleName].class = action.data.classname;
        cstate.headerIcons[moduleName].textLabelClass = action.data.textLabelClass;
        if (moduleName === Modules.CHAT) {
          cstate.headerIcons[moduleName].logo = (action.data.classname.indexOf('moduleIconActive') != -1) ? cstate.headerIcons[moduleName].logo_active : cstate.headerIcons[moduleName].logo_deactive;
        } else if (moduleName === Modules.SCREENSHARE || moduleName === Modules.CO_BROWSE) {
          cstate.headerIcons[moduleName].logo = (action.data.classname.indexOf('moduleIconActive') != -1) ? cstate.headerIcons[moduleName].logo_active : (!cstate.isPresenter) ? cstate.headerIcons[moduleName].logo_disable : cstate.headerIcons[moduleName].logo_deactive;
        } else {
          cstate.headerIcons[moduleName].logo = (action.data.classname.indexOf('moduleIconActive') != -1) ? cstate.headerIcons[moduleName].logo_active : (cstate.sessionDetails.role === USER_ROLES.USER) ? cstate.headerIcons[moduleName].logo_disable : cstate.headerIcons[moduleName].logo_deactive;
        }
      }
      return cstate;
    case ACTIONS.SET_SNAPSHOTEE_ID:
      return {
        ...state,
        snapshoteeId: action.snapshoteeId
      };
    case ACTIONS.SET_SNAPSHOTER_ID:
      return {
        ...state,
        snapshoterId: action.snapshoterId
      };
    case ACTIONS.SET_SNAPSHOT_PERMISSION_REPLY:
      return {
        ...state,
        snapshotPermissionReply: action.snapshotPermissionReply
      };
    case ACTIONS.RESET_SNAPSHOT_DATA:
      return {
        ...state,
        snapshotPermissionReply: null,
        snapshoteeId: null,
        snapshoterId: null,
        isSnapshotTaken: null
      };
      break;
    case ACTIONS.SET_SNAPSHOT_TAKEN:
      return {
        ...state,
        isSnapshotTaken: action.isSnapshotTaken
      };
      break;
    case ACTIONS.SET_SWITCH_CAMERA:
      return {
        ...state,
        isPeerDisposed: action.isPeerDisposed
      };
      break;
    case ACTIONS.SNAPSHOT.SHOW_SNAPSHOT:
      return {
        ...state,
        showSnapshot: action.value
      }
    case ACTIONS.RESET_ALL_PARTICIPANT_MEDIA_STATUS:
      return {
        ...state,
        webRtcPermissionRequest: null,
        webRtcPermissionReply: null
      };
    case ACTIONS.LEAVE_SESSION_LOCAL:
      return {
        ...initialState,
        sessionDetails: { sessionKey: state.sessionDetails.sessionKey, token: state.sessionDetails.token }
      };
    case ACTIONS.CALL_STATUS:
      return {
        ...state,
        isCallEnded: action.value
      };
    case ACTIONS.CALL_MODAL_PERMISSION:
      return {
        ...state,
        showAudioVideoComponent: action.value
      };
    case ACTIONS.SET_WEBRTC_SESSION_MEDIA:
      return {
        ...state,
        webrtcSessionMedia: action.value
      }
    case ACTIONS.SNAPSHOT.SET_SNAPSHOT_CAMERA_PERMISSION:
      return {
        ...state,
        isCameraPermissionGranted: action.value
      }
    case ACTIONS.STOP_VIDEO_CALL:
      return {
        ...state,
        stopVideoCall: action.value
      }
    case ACTIONS.START_VIDEO_CALL:
      return {
        ...state,
        startVideoCall: action.value
      }
    case ACTIONS.SET_CAMERA_BUSY_FLAG:
      return {
        ...state,
        isCameraBusy: action.value
      }
    case ACTIONS.SET_TURN_SERVER_DATA:
      return {
        ...state,
        turnServer: action.turnServer
      }
    case ACTIONS.REMOVE_TOKEN_SESSION_KEY:
      return {
        ...initialState,
        sessionDetails: { sessionKey: "", token: "" }
      }
    case ACTIONS.CREATE_SNAPSHOT_RTC_PEER:
      return {
        ...state,
        createSnapshotRtcPeer: action.value
      }
    case ACTIONS.START_SNAPSHOT:
      return {
        ...state,
        startSnapshot: action.value
      }
    case ACTIONS.SET_CALL_MEDIA_TYPE:
      return {
        ...state,
        callMediaType: action.mediaType
      }
    case ACTIONS.SET_COMPONENT_IN_FOCUS:
      return {
        ...state,
        componentInFocus: action.componentInFocus
      };
    case ACTIONS.SET_SESSION_SCHEDULE_LIST:
      return {
        ...state,
        sessionsList : action.value
      }  
    case ACTIONS.SET_SAVE_SESSION_DATA_FLAG:
      return {
        ...state,
        saveSessionDataFlag: action.flag
      };
      break;
    case ACTIONS.SET_SESSION_TYPE:
      return {
        ...state,
        sessionType: action.sessionType
      };
    case ACTIONS.SET_EDIT_SESSION_DATA:
      return{
        ...state,
        editSessionData: action.session
      }
    case ACTIONS.SET_PASSCODE:
      return{
        ...state,
        passcode: action.passcode
      }
    case ACTIONS.SET_LOCAL_STREAM:
      return {
        ...state,
        localStream: action.localStream
      };
    case ACTIONS.SET_TRAIL_HISTORY_DATA:
      return {
        ...state,
        trailHistoryData: action.trailHistoryData
      };
    case ACTIONS.SET_WAITING_USERS_DATA:
      return {
        ...state,
        waitingUsersData: action.waitingUsersData
      };
    case ACTIONS.SET_IS_RECORDING:
      return {
        ...state,
        isRecording: action.value
      };
    case ACTIONS.SET_IS_SCREEN_MASKING:
      return {
        ...state,
        isScreenMasking: action.value
      };
    case ACTIONS.SET_RUN_SCREEN_SHARE:
      return {
        ...state,
        runScreenShare: action.value
      };
    case ACTIONS.SET_PREVIEW_MODAL:
      return {
        ...state,
        showPreviewModal: action.value
      };
    case ACTIONS.SET_VIDEO_TRANSFORM:
      return {
        ...state,
        isVideoTransform: action.value
      };
    case ACTIONS.SET_PREVIEW_AUDIO:
      return {
        ...state,
        previewAudio: action.value
      };
    case ACTIONS.SET_MEDIA_DEVICE:
      return {
        ...state,
        audioDeviceId: action.audioDeviceId,
        videoDeviceId: action.videoDeviceId,
      };
    case ACTIONS.SET_VIDEO_DEVICE:
      return {
        ...state,
        videoDeviceId: action.value,
      };
    case ACTIONS.SET_FACING_MODE:
      return {
        ...state,
        facingMode: action.value,
      };
    case ACTIONS.SET_VIRTUAL_BACKGROUND:
      return {
        ...state,
        isVirtualBackground: action.isVirtualBackground,
        selectedBackground: action.selectedBackground,
      };
    case ACTIONS.SET_AUDIO_SETTING_MODAL:
      return {
        ...state,
        showAudioSettingModal: action.value
      };
    case ACTIONS.SET_IS_PRESENTER:
      return {
        ...state,
        isPresenter: action.value,
      };
    case ACTIONS.SET_IS_FULLSCREEN_V2:
      return {
        ...state,
        isFullScreenV2: action.value,
      };
    case ACTIONS.SET_IS_CALLING:
      return {
        ...state,
        userSessionDetails: {
          ...state.userSessionDetails,
          isCalling: action.value
        }
      };
    case ACTIONS.SET_CONTRACT_INFO:
      return {
        ...state,
        contractInfo: action.value
      };
    case ACTIONS.SET_IS_CONTRACT_INFO_MODAL_OPENED:
      return {
        ...state,
        isContractInfoModalOpened: action.value
      };
    case ACTIONS.SET_IS_DISCONNECTED_WHILE_CALLING:
      return {
        ...state,
        isDisconnectedWhileCalling: action.value,
      };
    default:
      return state;
  }
}
